// extracted by mini-css-extract-plugin
export var actionButton = "_4p-0";
export var dropdown = "_4p-1";
export var grayBackground = "_4p-2";
export var instruction = "_4p-3";
export var selectedTag = "_4p-4";
export var unselectedTag = "_4p-5";
export var wide = "_4p-6";
export var wrapper = "_4p-7";